

























































import HangupIcon from '@/components/icons/HangupIcon.vue';
import MinimizeIcon from '@/components/icons/MinimizeIcon.vue';
import { Prop, Component } from 'vue-property-decorator';
import LogPageEventMixin, {
  PAGE_TRACKING,
  PAGE_EVENTS,
} from '@/mixins/logPageEvent';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';
import * as vtsx from 'vue-tsx-support';
import { compareVersionNumbers } from '@/vendor/pleased-sdk/util';
import { checkVersionSupported } from '@/common/bot/flow-frameworks/VersionCheck.static';

interface PropTypes {
  voiceChatId: number | null;
  onClose: () => void;
  onCall: () => void;
  onDestroy: () => void;
  onMinimize: () => void;
}

enum stepEnum {
  CONNECTING,
  CONNECTED
}

@Component({
  components: { HangupIcon, MinimizeIcon },
  filters: {
    formatTime (distance: number) {
      const minute = 60;
      const hour = minute * 60;
      const day = hour * 24;
      const hours = Math.floor((distance % day) / hour);
      const mins = Math.floor((distance % hour) / minute);
      const secs = Math.floor(distance % minute);
      const paddingDigit = (val: number) => (val > 9 ? val : `0${val}`);
      return `${paddingDigit(hours)}:${paddingDigit(mins)}:${paddingDigit(
        secs
      )}`;
    },
  },
  mixins: [LogPageEventMixin],
  directives: {
    trackClick,
  },
})
export default class Voice extends vtsx.Component<PropTypes> {
  @Prop(Number) readonly voiceChatId!: number | null;

  readonly BTN_EVTS = BTN_EVTS;

  get [PAGE_TRACKING] () {
    return {
      name: PAGE_EVENTS.VOICE_CHAT,
      selection: this.voiceChatId,
    };
  }

  get showMinimize () {
    return checkVersionSupported('voiceMinimize', false);
  }

  time = 0;
  stepEnum = stepEnum;
  currentStep = stepEnum['CONNECTING'];
  timerId = 0;

  mounted () {
    document.title = 'Voice Call';
    this.$emit('call', this);
  }
  beforeDestroy () {
    clearTimeout(this.timerId);
    this.$emit('destroy');
  }
  handleConnected () {
    this.currentStep = stepEnum['CONNECTED'];
    this.timerId = window.setInterval(() => {
      this.time += 1;
    }, 1000);
  }
  handleHangUp () {
    this.$emit('close');
  }
  minimize () {
    this.$emit('minimize');
  }
}
